import {useMutation} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface UseReopenPullRequestArgs {
  repoNwo?: string
  prNumber?: number
}

export function useReopenPullRequest({repoNwo, prNumber}: UseReopenPullRequestArgs) {
  return useMutation({
    mutationKey: ['reopenPullRequest', repoNwo, prNumber],
    mutationFn: async () => {
      if (!repoNwo || !prNumber) {
        throw new Error('Missing required repoNwo or prNumber to reopen pull request')
      }
      const response = await verifiedFetchJSON(`/${repoNwo}/pull/${prNumber}/page_data/reopen_pull_request`, {
        method: 'POST',
      })
      if (!response.ok) {
        throw new Error('Failed to reopen pull request')
      }
      return response
    },
  })
}
